import axios from "axios";
import {
  forceAuthLogout,
  getFreshAccessToken,
  isInvalidGrantError,
  isSessionExpiredResponse,
  refreshAccessToken,
} from "./authTokenService";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

//instance.defaults.headers.common['Content-Type'] = "application/json";
instance.defaults.headers.common["Content-Type"] = "application/x-www-form-urlencoded";
// instance.defaults.headers.common['Access-Control-Allow-Origin'] = "*";

const ensureHeaders = (request) => {
  request.headers = request.headers || {};
  return request.headers;
};

const setAuthorizationHeader = (headers, token) => {
  if (!token) return;
  if (typeof headers?.setAuthorization === "function") {
    headers.setAuthorization(`Bearer ${token}`);
    return;
  }
  headers.Authorization = `Bearer ${token}`;
};

const retryWithFreshToken = async (request) => {
  if (!request || request._retryWithFreshToken) {
    forceAuthLogout();
    return Promise.reject(new Error("Session expired"));
  }

  request._retryWithFreshToken = true;
  const token = await refreshAccessToken();
  setAuthorizationHeader(ensureHeaders(request), token);
  return instance(request);
};

instance.interceptors.request.use(
  async (request) => {
    try {
      const token = await getFreshAccessToken();
      if (token) {
        setAuthorizationHeader(ensureHeaders(request), token);
      }
      return request;
    } catch (error) {
      if (isInvalidGrantError(error)) {
        forceAuthLogout();
      }
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  async (response) => {
    if (isSessionExpiredResponse(response)) {
      try {
        return await retryWithFreshToken(response.config);
      } catch (error) {
        forceAuthLogout();
        return Promise.reject(error);
      }
    }
    return response;
  },
  async (error) => {
    if (isSessionExpiredResponse(error?.response)) {
      try {
        return await retryWithFreshToken(error.config);
      } catch (refreshError) {
        forceAuthLogout();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
